import { Button, Dialog, DialogContent, Grid, IconButton, TextField, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import { postTipoTarea } from '../../../services/apis';
import CancelIcon from '@mui/icons-material/Cancel';

export const FormCrearTipoTarea = ({ open, setOpen, cargarEstados }) => {
    const [tipoTarea, setTipoTarea] = useState({
        nombre: '',
        descripcion: '',
        color: '#000000' // Color por defecto
    });
    const [errorAlert, setErrorAlert] = useState(false);
    const [erroRespues, setErroRespues] = useState(false);

    const colorInputRef = useRef(null);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setTipoTarea(prev => ({ ...prev, [name]: value }));
        setErrorAlert(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const crearTipoTarea = async (tipoTarea) => {
        try {
            const response = await postTipoTarea(tipoTarea);
            console.log("Respuesta del servidor:", tipoTarea, response);

            if (response.success === true) {
                cargarEstados();
                setTipoTarea({ nombre: '', descripcion: '', color: '#000000' });
                handleClose();
            } else {
                setErroRespues(response.error);
            }
        } catch (error) {
            console.error("Error al crear el tipo de tarea", error);
            setErroRespues(true);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <DialogContent>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={11}
                    >
                        <Typography variant="h6" gutterBottom>
                            Crear Tipo De Tarea
                        </Typography>

                        <IconButton aria-label="close" onClick={handleClose}>
                            <CancelIcon color='primary' sx={{ fontSize: 30 }} />
                        </IconButton>
                    </Grid>

                    <Grid item xs={11}>
                        <TextField
                            label="Nombre Tipo De Tarea"
                            variant="outlined"
                            fullWidth
                            name="nombre"
                            value={tipoTarea.nombre}
                            onChange={handleChange}
                            required
                        />
                    </Grid>

                    <Grid item xs={11}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Typography variant='body1'>
                                Color del Tipo De Tarea
                            </Typography>
                            <input
                                type="color"
                                ref={colorInputRef}
                                name="color"
                                value={tipoTarea.color}
                                onChange={handleChange}
                                id="primary_color"
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={11} container justifyContent="flex-end">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (!tipoTarea.nombre || !tipoTarea.color) {
                                    setErrorAlert(true);
                                    return;
                                }
                                console.log('Nuevo tipo de tarea:', tipoTarea);
                                crearTipoTarea(tipoTarea);
                            }}
                        >
                            Crear
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>

            {errorAlert && (
                <AlertError
                    open={errorAlert}
                    setOpen={setErrorAlert}
                    titulo="Error"
                    mensaje="Falta rellenar algún campo obligatorio"
                />
            )}
        </Dialog>
    );
};
